import React from "react";

import { CollectionDetailListItemInput } from "./CollectionDetailListItemInput";
// import { CollectionDetailListItemCheck } from './CollectionDetailListItemCheck';

export class CollectionDetailListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    if (
      !this.props.isRecorded &&
      !this.props.header &&
      !this.props.item.collected &&
      !this.props.item.delivered
    ) {
      this.setCollectionItemDefault();
    }
  }

  setCollectionItemProperty(property, value) {
    if (this.props.isRecorded) {
      if (this.props.onRecordedEditAttempt) {
        this.props.onRecordedEditAttempt();
      }
      return;
    }
    const item = this.props.item;
    item[property] = value;
    if ((property === "collected" || property === "delivered") && value > 0) {
      item.completed = true;
    }
    this.props.updateCollectionItem(item);
  }

  handleRecordedInputInteraction(event) {
    if (this.props.isRecorded && this.props.onRecordedEditAttempt) {
      event.preventDefault();
      this.props.onRecordedEditAttempt();
    }
  }

  setCollectionItemDefault() {
    this.setCollectionItemProperty("collected", "");
    this.setCollectionItemProperty("delivered", "");
  }

  renderExpectedQty(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    return (
      <div className="cwi-expected" title="Expected quantity">
        {value}
      </div>
    );
  }

  render() {
    const canCollect =
      this.props.item.service === "Collection" ||
      this.props.item.service === "Exchange";
    const canDeliver = this.props.item.service !== "Collection";
    const onInteract = this.handleRecordedInputInteraction.bind(this);

    return (
      <div className="collection-waste-info">
        <div className="collection-waste-info-label">Name:</div>
        <div className="collection-waste-info-text">
          {this.props.item.name
            ? this.props.item.service + " - " + this.props.item.name
            : this.props.item.service}
        </div>
        <div className="collection-waste-info-label">Collected:</div>
        <div className="collection-waste-info-input cwi-collected">
          <div className="cwi-qty-row">
            {canCollect &&
              this.renderExpectedQty(this.props.item.expected_collected)}
            {canCollect ? (
              <CollectionDetailListItemInput
                classes={this.props.isRecorded ? "input-disabled" : ""}
                defaultValue={this.props.item.collected || ""}
                placeholder={"0"}
                disable={!!this.props.isRecorded}
                handleInputChange={this.setCollectionItemProperty.bind(this)}
                propertyName="collected"
                onInteract={onInteract}
              />
            ) : (
              <CollectionDetailListItemInput
                classes="input-disabled"
                defaultValue={""}
                disable={true}
                handleInputChange={this.setCollectionItemProperty.bind(this)}
                propertyName="collected"
                onInteract={onInteract}
              />
            )}
          </div>
        </div>
        <div className="collection-waste-info-label">EWC Code:</div>
        <div className="collection-waste-info-text">
          {this.props.item.ewc_code ? this.props.item.ewc_code : "-"}
        </div>
        <div className="collection-waste-info-label">Delivered:</div>
        <div className="collection-waste-info-input cwi-delivered">
          <div className="cwi-qty-row">
            {canDeliver &&
              this.renderExpectedQty(this.props.item.expected_delivered)}
            {canDeliver ? (
              <CollectionDetailListItemInput
                classes={this.props.isRecorded ? "input-disabled" : ""}
                defaultValue={this.props.item.delivered || ""}
                placeholder={"0"}
                disable={!!this.props.isRecorded}
                handleInputChange={this.setCollectionItemProperty.bind(this)}
                propertyName="delivered"
                onInteract={onInteract}
              />
            ) : (
              <CollectionDetailListItemInput
                classes="input-disabled"
                defaultValue={""}
                disable={true}
                handleInputChange={this.setCollectionItemProperty.bind(this)}
                propertyName="delivered"
                onInteract={onInteract}
              />
            )}
          </div>
        </div>
        <div className="collection-waste-info-label">Haz Code:</div>
        <div className="collection-waste-info-text">
          {this.props.item.haz_code ? this.props.item.haz_code : "-"}
        </div>
        <div className="collection-waste-info-label">Weight(kg):</div>
        <div className="collection-waste-info-input cwi-weight">
          {this.props.item.service === "Collection" ||
          this.props.item.service === "Delivery" ||
          this.props.item.service === "Exchange" ? (
            <CollectionDetailListItemInput
              classes={this.props.isRecorded ? "input-disabled" : ""}
              defaultValue={
                this.props.item.weight && this.props.item.weight != "0.00"
                  ? this.props.item.weight
                  : ""
              }
              placeholder={"0.00"}
              disable={!!this.props.isRecorded}
              handleInputChange={this.setCollectionItemProperty.bind(this)}
              propertyName="weight"
              onInteract={onInteract}
            />
          ) : (
            <CollectionDetailListItemInput
              classes="input-disabled"
              defaultValue={""}
              disable={true}
              handleInputChange={this.setCollectionItemProperty.bind(this)}
              propertyName="weight"
              onInteract={onInteract}
            />
          )}
        </div>
        <div className="collection-waste-info-label">Notes:</div>
        <div className="collection-waste-info-text text-red">
          {this.props.item.driver_notes ? this.props.item.driver_notes : "-"}
        </div>
      </div>
    );
  }
}
